import {FC} from 'react';
import {Box, Card, CardContent, CircularProgress, Grid, Typography, Alert} from '@mui/material';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer} from 'recharts';
import {useTtsDashboard} from '../../hooks/useTts.ts';

const TtsDashboard: FC = () => {
    const {data, isLoading, error} = useTtsDashboard();

    if (isLoading) return <Box sx={{display: 'flex', justifyContent: 'center', p: 4}}><CircularProgress/></Box>;
    if (error) return <Alert severity="error">대시보드 로드 실패: {error.message}</Alert>;
    if (!data) return null;

    const usagePercent = data.monthlyCharLimit > 0
        ? Math.round((data.monthlyCharCount / data.monthlyCharLimit) * 100)
        : 0;

    const cards = [
        {label: '총 생성 완료', value: data.totalAudio.toLocaleString(), color: '#1976d2'},
        {
            label: '월간 사용량',
            value: `${data.monthlyCharCount.toLocaleString()} / ${data.monthlyCharLimit.toLocaleString()} (${usagePercent}%)`,
            color: usagePercent > 80 ? '#ed6c02' : '#2e7d32',
        },
    ];

    return (
        <Box>
            <Grid container spacing={2} sx={{mb: 3}}>
                {cards.map((card) => (
                    <Grid size={{xs: 12, sm: 6, md: 4}} key={card.label}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="caption" color="text.secondary">{card.label}</Typography>
                                <Typography variant="h5" sx={{color: card.color, fontWeight: 600}}>
                                    {card.value}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {(data.langDistribution ?? []).length > 0 && (
                <Card variant="outlined">
                    <CardContent>
                        <Typography variant="subtitle2" gutterBottom>언어별 분포</Typography>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={data.langDistribution}>
                                <CartesianGrid strokeDasharray="3 3"/>
                                <XAxis dataKey="lang" tick={{fontSize: 12}}/>
                                <YAxis tick={{fontSize: 12}}/>
                                <Tooltip/>
                                <Bar dataKey="count" fill="#1976d2" radius={[4, 4, 0, 0]}/>
                            </BarChart>
                        </ResponsiveContainer>
                    </CardContent>
                </Card>
            )}
        </Box>
    );
};

export default TtsDashboard;
